import { Controller } from '@hotwired/stimulus';

export default class PepDescriptionController extends Controller {
  static values = { description: String };
  static targets = ['otherField', 'associateField'];

  descriptionValueChanged(description) {
    this.#updateFields(description);
  }

  toggle(event) {
    this.descriptionValue = event.target.value;
  }

  #updateFields(value) {
    if (this.hasOtherFieldTarget) {
      this.otherFieldTarget.disabled = value !== 'other';
    }
    if (this.hasAssociateFieldTarget) {
      this.associateFieldTarget.disabled = value !== 'other_2';
    }
  }
}
